// Defer Third-Party Scripts to Reduce TBT (Total Blocking Time)
// Add this to theme.liquid before </body>

(function() {
    'use strict';

    // Configuration: Add third-party script patterns to defer
    var deferScripts = [
        'judge.me',
        'klaviyo',
        'loox',
        'yotpo',
        'smile.io',
        'privy',
        'gorgias',
        'tidio',
        'tawk.to',
        'intercom',
        'zendesk',
        'hotjar',
        'luckyorange',
        'criteo',
        'taboola',
        'outbrain',
        'facebook.net',
        'connect.facebook',
        'googletagmanager',
        'google-analytics',
        'googleadservices',
        'doubleclick.net',
        'bing.com/scripts',
        'pinterest.com/ct',
        'snapchat.com/pixel',
        'tiktok.com/pixel',

        // Social & Chat
        'instagram.com/embed',
        'twitter.com/widgets',
        'linkedin.com/embed',

        // Other common
        'recaptcha',
        'trustpilot',
        'bazaarvoice'
    ];

    // Critical scripts that should NOT be deferred
    var criticalScripts = [
        'shopify.com/s/files',
        'cdn.shopify.com/s/files',
        'checkout',
        'cart',
        'theme.js',
        'jquery'
    ];

    var deferredScripts = [];
    var scriptsLoaded = false;

    // Check if script should be deferred
    function shouldDefer(src) {
        if (!src) return false;

        // Never touch/replay obviously broken URLs
        if (src.includes('/undefined') || src.includes('/null') || src.endsWith('undefined')) {
            return false;
        }

        for (var i = 0; i < criticalScripts.length; i++) {
            if (src.includes(criticalScripts[i])) {
                return false;
            }
        }

        for (var i = 0; i < deferScripts.length; i++) {
            if (src.includes(deferScripts[i])) {
                return true;
            }
        }

        return false;
    }

    // Defer script execution (single definition — do not duplicate this function)
    function deferScript(script) {
        var src = script.src || script.getAttribute('src');

        if (src && src.includes('/undefined')) {
            console.warn('BROKEN SCRIPT CAPTURED:', script.outerHTML);
        }

        if (shouldDefer(src)) {
            // Dedupe — don't queue the same src twice
            var alreadyQueued = deferredScripts.some(function (s) {
                return s.src === src;
            });
            if (alreadyQueued) return false;

            // Store original script info
            deferredScripts.push({
                src: src,
                async: script.async,
                defer: script.defer,
                type: script.type,
                id: script.id,
                className: script.className,
                dataset: script.dataset
            });

            // Replace script with placeholder
            script.type = 'text/deferred';
            script.removeAttribute('src');

            return true;
        }

        return false;
    }

    // Load deferred scripts
    function loadDeferredScripts() {
        if (scriptsLoaded) return;
        scriptsLoaded = true;

        deferredScripts.forEach(function(scriptData, index) {
            setTimeout(function() {
                if (scriptData.inline) return; // inline scripts aren't re-injected this way

                var script = document.createElement('script');
                script.src = scriptData.src;
                script.async = true;

                if (scriptData.id) script.id = scriptData.id;
                if (scriptData.className) script.className = scriptData.className;
                if (scriptData.dataset) {
                    Object.keys(scriptData.dataset).forEach(function(key) {
                        script.dataset[key] = scriptData.dataset[key];
                    });
                }

                document.body.appendChild(script);
            }, index * 100);
        });
    }

    // Intercept inline scripts that load third-party content
    function interceptInlineScripts() {
        var inlineScripts = document.querySelectorAll('script:not([src])');

        inlineScripts.forEach(function(script) {
            var content = script.innerHTML;
            var shouldDeferInline = false;

            deferScripts.forEach(function(pattern) {
                if (content.includes(pattern)) {
                    shouldDeferInline = true;
                }
            });

            if (shouldDeferInline) {
                script.type = 'text/deferred';
                deferredScripts.push({
                    inline: true,
                    content: content
                });
            }
        });
    }

    // Process existing scripts
    function processExistingScripts() {
        var scripts = document.querySelectorAll('script[src]');
        var deferredCount = 0;

        scripts.forEach(function(script) {
            if (deferScript(script)) {
                deferredCount++;
            }
        });
    }

    // MutationObserver to catch dynamically added scripts
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.tagName === 'SCRIPT') {
                    // Wait a tick so late-set src attributes have resolved
                    setTimeout(function () {
                        if (node.src && !scriptsLoaded) {
                            deferScript(node);
                        }
                    }, 0);
                }
            });
        });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

    // Load deferred scripts on user interaction
    var loadTriggers = ['scroll', 'mousemove', 'touchstart', 'click', 'keydown'];
    var triggered = false;

    function triggerLoad() {
        if (triggered) return;
        triggered = true;

        loadTriggers.forEach(function(event) {
            window.removeEventListener(event, triggerLoad);
        });

        setTimeout(loadDeferredScripts, 100);
    }

    loadTriggers.forEach(function(event) {
        window.addEventListener(event, triggerLoad, { passive: true, once: true });
    });

    // Fallback: Load after 3 seconds if no interaction
    setTimeout(function() {
        if (!scriptsLoaded) {
            loadDeferredScripts();
        }
    }, 3000);

    // Process scripts when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            processExistingScripts();
            interceptInlineScripts();
        });
    } else {
        processExistingScripts();
        interceptInlineScripts();
    }

    // Expose function to manually load scripts
    window.loadDeferredScripts = loadDeferredScripts;

})();

// Additional: Defer Shopify App Scripts specifically
(function() {
    var appScriptPatterns = [
        /\/apps\/[^\/]+\/assets/,
        /\/wpm@/,
        /\/app_[^\/]+\.js/,
        /extensions\/[^\/]+\/assets/
    ];

    window.addEventListener('load', function() {
        setTimeout(function() {
            var scripts = document.querySelectorAll('script[src]');

            scripts.forEach(function(script) {
                var src = script.src;
                var isAppScript = appScriptPatterns.some(function(pattern) {
                    return pattern.test(src);
                });

                if (isAppScript && !script.async && !script.defer) {
                    // Found a blocking app script — logging removed, add back if debugging
                }
            });
        }, 1000);
    });
})();